import styled from 'styled-components';
import {BLACK, dFlex, mobileMedia, scrollbar} from '../../../../globalVariables/GlobalVariables';
import {wrapper} from '../stepRight/StepRight.css';
import {wrapper as wrapperLeft} from '../StepLeft/StepLeft.css';
import {iframe} from '../../../../layout/myIframe/MyIframe.css';
import {checkbox} from '../../../../component/checkbox/Checkbox.css';
import {btn} from '../../../../component/button/btn/Btn.css';
import {text, wrapCheckbox} from '../../../../component/checkboxFormik/CheckboxFormik.css';
import {alignStart, flexRow, justifyBetween, justifyEnd} from '../../../../globalVariables/GlobalFlex';

export const wrap = styled.div`
    width: 100%;
    padding-block-end: 15px;
    ${p => p.$hasPop && `
        .arrow {
            display: none;
        }
    `}
    input{
         color: ${BLACK};
    }
    ${wrapper}{
        width: 100%;
    }
    ${btn}{
        border-color:${BLACK} ;
        &:hover{
            color:${BLACK};
            border-color:${BLACK};
        }
    }
    ${wrapperLeft}{
        width: 100%;
        ${flexRow};
        ${alignStart};
        ${p=>p.$hasPop?justifyEnd:justifyBetween};
        ${mobileMedia}{
            ${dFlex};
            ${flexRow};
            gap: 10px;
        }
    }
`;
export const wrapContent=styled.div`
    height:350px;
    position: relative;
    ${iframe}{
        height: calc(100% - 40px);
    }
    ${mobileMedia}{
        height:250px;
    }
`;

export const wrapSvg=styled.div`
    display:flex;
    padding-block:15px;
    ${mobileMedia}{
    display:grid;
    grid-template-columns: repeat(3 , 180px);
    gap: 10px;
        ${scrollbar};
        padding-inline:10px;
    }
`;
export const newBadge = styled.span`
    display: inline-block;
    background: linear-gradient(90deg, #7c3aed, #2563eb);
    color: #fff;
    font-size: 10px;
    font-weight: 800;
    padding: 2px 9px;
    border-radius: 10px;
    letter-spacing: 0.5px;
    white-space: nowrap;
`;
export const newPreview = styled.div`
    height: 100%;
    ${dFlex};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: #f8fafc;
    border: 1.5px dashed #c7d2fe;
    border-radius: 12px;
    .title {
        font-size: 18px;
        font-weight: 700;
    }
    .cap {
        font-size: 13px;
        color: #64748b;
    }
    .note {
        font-size: 12px;
        color: #94a3b8;
        max-width: 420px;
        text-align: center;
        padding-inline: 12px;
    }
`;
export const wrapButtons = styled.div`
    ${btn}{
        margin-bottom: 10px;
    }
    ${wrapCheckbox}{
        padding-inline-start:0;
    }
    ${mobileMedia}{
        display:unset;
        ${btn}{
            width: 90px;
        }
    }
    ${text}{
        font-weight: 600;
        font-size: 12px;
        width:max-content;
        margin-inline-start: 5px;
    }
    ${wrapCheckbox}{
        width:unset;
        input[type=checkbox]:before {
         content: unset;
        }
         input[type=checkbox]:checked:after{
         content:unset;
         }
    }
    ${checkbox}{
        &.selected{
            &::before{
                background:black;
                right: calc(50% - 3px);
                top: calc(50% - 3px);
            }
        }
    }
`;

